import { LOCALES } from '../../../../utils/constants';

export const VIDEO_PREVIEW_VIDEO_URL = 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/815b6fe5bd4cbf622ccf52576bda2e8b-1635427050879/brand%20campaign%20preview%20LP%20update%20CC';
export const THUMBNAIL_PREVIEW_URL = 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/cb02b486474aaf6412c46c15a8328859-1635227156956/brand_campaign_thumb_large.jpg';

export const BRAND_LANG_URL = {
    [LOCALES.en]: {
        CTA: 'https://something-from-nothing.fiverr.com',
        VIDEO: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/3bddc1919d4fea943ef1d10082c16759-1635228482241/Brand%20Campagin%20low%20res%20english'
    },
    [LOCALES.de]: {
        CTA: 'https://something-from-nothing.fiverr.com/de',
        VIDEO: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/e62c821daa83a446240db6b5e0e6fc93-1635323898955/Brand%20Campagin%20low%20res%20german'
    }
};
